import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Checkbox consenso marketing dei moduli pubblici: usa il testo legale del
// ristorante (Impostazioni → Privacy e GDPR → Marketing) con link all'informativa.
export function ConsensoMarketing({ rid, checked, onChange, testid, accentColor }) {
  const [legal, setLegal] = useState(null);
  useEffect(() => {
    if (!rid) return;
    fetch(`${API}/api/public/legal/${rid}?tipo=marketing`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => d && setLegal(d))
      .catch(() => {});
  }, [rid]);

  return (
    <label className="flex items-start gap-2 text-xs text-zinc-500" data-testid={`${testid}-wrap`}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)}
        className="w-4 h-4 mt-0.5 shrink-0" data-testid={testid}
        style={accentColor ? { accentColor } : undefined} />
      <span>
        {legal?.testo || "Acconsento a ricevere comunicazioni e offerte dal ristorante (facoltativo)."}{" "}
        <a href={`/p/${rid}/privacy`} target="_blank" rel="noreferrer"
          className="underline font-medium hover:text-zinc-700" data-testid={`${testid}-privacy-link`}>
          Leggi l'informativa
        </a>
      </span>
    </label>
  );
}
